"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>TryAgain_TryAgain
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_pcln_icons_namespaceObject = require("pcln-icons");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const analytics_js_namespaceObject = require("../../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const useChatUIContext_js_namespaceObject = require("../../hooks/useChatUIContext.js");
const useLoadingStateContext_js_namespaceObject = require("../../hooks/useLoadingStateContext.js");
const TryAgain = ({ lastMessage })=>{
    (0, external_react_namespaceObject.useEffect)(()=>{
        analytics_js_default().log({
            message: `TryAgain-component: ${lastMessage}`,
            source: 'TryAgain'
        });
    }, [
        lastMessage
    ]);
    let setOpenErrorComponent, setLoadingStatus;
    try {
        const chatUIContext = (0, useChatUIContext_js_namespaceObject.useChatUIContext)();
        setOpenErrorComponent = chatUIContext?.setOpenErrorComponent;
    } catch (error) {
        console.warn('TryAgain: useChatUIContext must be used within a ChatUIContextProvider');
        setOpenErrorComponent = ()=>{};
    }
    try {
        const loadingStateContext = (0, useLoadingStateContext_js_namespaceObject.useLoadingStateContext)();
        setLoadingStatus = loadingStateContext?.setLoadingStatus;
        (0, external_react_namespaceObject.useEffect)(()=>{
            if (setLoadingStatus) setLoadingStatus(false);
        }, [
            setLoadingStatus
        ]);
    } catch (error) {
        console.warn('TryAgain: useLoadingStateContext must be used within a LoadingStateProvider');
        setLoadingStatus = ()=>{};
    }
    const tryAgainHandler = function() {
        if (setOpenErrorComponent) setOpenErrorComponent(false);
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
        flexDirection: "column",
        justifyContent: "center",
        "data-testid": "try-again",
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.GenericBanner, {
            mx: 3,
            my: 3,
            p: 2,
            borderRadius: "lg",
            color: "background.light",
            iconLeft: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.InformationOutline, {
                color: "warning.base",
                "data-testid": "information-outline-icon"
            }),
            text: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text.span, {
                textStyle: "subheading6",
                children: [
                    "I'm having some trouble coming up with a response right now.\xa0",
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text.span, {
                        color: "primary.base",
                        textStyle: "heading6",
                        style: {
                            textDecoration: 'none !important'
                        },
                        children: "Please try again."
                    })
                ]
            }),
            buttonClick: tryAgainHandler
        })
    });
};
const TryAgain_TryAgain = TryAgain;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
